import { useStytchMember } from '@stytch/react/b2b'
import { Navigate } from 'react-router-dom'
import { OrdersProvider } from '@/contexts/OrdersContext'
import { DocumentsProvider } from '@/contexts/DocumentsContext'
import ErrorBoundary from './ErrorBoundary'

interface ProtectedRouteProps {
    children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { member, isInitialized } = useStytchMember()

    if (!isInitialized) {
        return <div>Loading...</div>
    }

    if (!member) {
        return <Navigate to="/login" replace />
    }

    return (
        <OrdersProvider>
            <DocumentsProvider>
                <ErrorBoundary>{children}</ErrorBoundary>
            </DocumentsProvider>
        </OrdersProvider>
    )
}

export default ProtectedRoute
